import Layout from "components/Layout";
import { EmtekPageProps } from "pages/[[...slug]]";

import { Toolbox, ToolboxBlock } from "./Toolbox";

export type PageProps = EmtekPageProps<{
    body: ToolboxBlock[];
}>;

const LandingPage: React.FC<PageProps> = (props) => {
    return (
        <Layout
            metadata={props.wagtail}
            menus={props.menus}
            //  promo={props.promo}
        >
            {props.wagtail.body.map((block, index) => {
                switch (block.type) {
                    default:
                        return (
                            <Toolbox
                                block={block}
                                key={block.id}
                                isFirstBlock={index === 0}
                            />
                        );
                }
            })}
        </Layout>
    );
};

export default LandingPage;
